// Number and comparison formatting, ported from the design's helpers
// (`r1`, `dl`, `dFg`, `pl`, `bin`). Every scale is 0–5 (README §3), never the
// design's 0–10.

export const RED = '#C23B2E';
export const GREEN = '#2F7A4D';

/** One decimal, always shown ("3.0"). `—` for a missing value. */
export const r1 = (v) => (v == null || Number.isNaN(v) ? '—' : (Math.round(v * 10) / 10).toFixed(1));

/** A value as it was logged: integers bare, anything else to one decimal. */
export const num = (v) => (v == null ? '—' : Number.isInteger(v) ? String(v) : r1(v));

/** "↑ 0.5" / "↓ 0.5" / "± 0" — the change from `b` to `a`. */
export function deltaText(a, b) {
  if (a == null || b == null) return 'Not enough data to compare';
  const d = Math.round((a - b) * 10) / 10;
  const n = Math.abs(d).toFixed(1);
  if (d > 0) return `↑ ${n}`;
  if (d < 0) return `↓ ${n}`;
  return '± 0';
}

/**
 * Colour for a delta text: red when worse, green when better. `worseUp` is
 * true for every metric except energy, where up is better.
 */
export function deltaColor(text, worseUp, fallback) {
  if (/^↑/.test(text || '')) return worseUp ? RED : GREEN;
  if (/^↓/.test(text || '')) return worseUp ? GREEN : RED;
  return fallback;
}

/** The summary cards' delta: one decimal always, with a suffix. Returns [text, colour]. */
export function cardDelta(a, b, worseUp, suffix) {
  if (a == null || b == null) return ['Not enough data to compare', '#6b6b6b'];
  const d = Math.round((a - b) * 10) / 10;
  const t = d > 0 ? `↑ ${d.toFixed(1)}` : d < 0 ? `↓ ${Math.abs(d).toFixed(1)}` : '± 0.0';
  return [`${t} ${suffix}`, d === 0 ? '#1f1f1f' : (d > 0) === worseUp ? RED : GREEN];
}

/** "1 day" / "3 days" */
export const pl = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;

/** Ramp bin 0–4 for a value on a 0–max scale (5 equal bins). */
export const bin = (v, max) => Math.max(0, Math.min(4, Math.ceil((v / max) * 5) - 1));

/** The low-logging warning, shown under 70 % of days logged. */
export const lowLog = (logged, total) =>
  total > 0 && logged / total < 0.7 ? `Only ${logged} of ${total} days logged` : '';

/** Mean of the non-null values, or null. */
export function mean(values) {
  const vs = values.filter((v) => v != null && !Number.isNaN(v));
  return vs.length ? vs.reduce((a, b) => a + b, 0) / vs.length : null;
}

export const capitalize = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);
